<template>
  <div class="how-it-work aside-item">
    <div class="aside-item-title">{{ $t('Как это работает') }}?</div>
    <div class="carousel-wrapper">
      <carousel :perPage="1" paginationActiveColor="#3c91e6" paginationColor="#f0f1f4" :paginationPadding="5">
        <slide class="slide">
          <app-img :src="require('../../../img/how-it-works-1.jpg')" alt=""></app-img>
          <div>{{ $t('Найдите нужный вам магазин, через наш поиск') }}</div>
        </slide>
        <slide class="slide">
          <app-img :src="require('../../../img/how-it-works-2.jpg')" alt=""></app-img>
          <div>{{ $t('Подберите промокод, который вам подходит') }}</div>
        </slide>
        <slide class="slide">
          <app-img :src="require('../../../img/how-it-works-3.jpg')" alt=""></app-img>
          <div>{{ $t('Нажмите "Показать промокод" скопируйте его и используйте') }}</div>
        </slide>
        <slide class="slide">
          <app-img :src="require('../../../img/how-it-works-4.jpg')" alt=""></app-img>
          <div>{{ $t('А так же воспользуйтесь Кэшбеком, чтобы сэкономить еще больше!') }}</div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import AppImg from '../AppImg.vue';

export default {
  name: 'shop-how',

  components: {
    AppImg
  },

  data() {
    return {};
  },

  methods: {}
};
</script>

<style scoped>
  .slide {
    text-align: center;
  }

  .slide img {
    margin: 0 auto;
    padding-bottom: 10px;
    height: 180px;
  }

  .slide div {
    font-size: 14px;
    line-height: 22px;
    text-align: center;
  }
</style>
